import { gql } from '@/__generated__';

export const StreamQuery = gql(`
query StreamQuery($id: ID!) {
  stream(id: $id) {
    id
    accessAllowed
    author {
      ...UserBadgeFragment
    }
    name
    description
    canAddToStreamDeck
    descriptionJson
    following
    label
    streamCategory
    streamState
    streamType
    isEmpty
    isFeatured
    followersCount
    protectedFields {
      streamApiKeys {
        ...ApiKeyFragment
      }
    }
    paidData {
      ...StripePriceFragment
    }
    subscription {
      cancelAt
      active
      price
      customTargets
      interval
      intervalCount
      signupTrial
    }
    inPackages {
      ...PackageInStreamFragment
    }
    packageOnly
    apiAccessEnabled
    customTargetsData {
      ...CustomTargetsDataFragment
    }
    customTargets
  }
}
`);

gql(`
fragment PackageInStreamFragment on StreamPackage {
  id
  name
  packagePaidData: paidData {
    ...StripePriceFragment
  }
  subscription {
    active
  }
}
`);

gql(`
  fragment CustomTargetsDataFragment on CustomTargetsData {
    maxTargets
    maxTotalTargets
    minTargets
    stepSize
    targetTypeInstruction
    targetType
    targetValidationRegex
  }
`);

gql(`
  fragment StripePriceFragment on StripePrice {
    id
    amount
    interval
    intervalCount
  }
`);
